<template>

  <main id="renew2_login" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="login_container" v-if="!registerComple">
      <div class="renew2_wrapper renew2_flex">
        <div class="login_contents">
          <div class="renew2_flex lead">
            <h2>ヤギプライムをはじめよう <span><a href="/yagiprimeinfo" target="_blank" class="notelink-icon">？</a></span></h2>
          </div>
          <p>Yagishの<a href="/terms" id="footer-link-terms" target="_blank">利用規約</a>、<a href="/privacy"
              id="footer-link-terms" target="_blank">個人情報の取り扱いについて</a>、<img
              src="/static/renew3_img/carat_img/caratcheck_icon.svg" alt="チェック" class="check_icon" style="">
            <a href="/yagiprimeterms" target="_blank">ヤギプライム利用規約</a>に同意の上、ヤギプライムにご登録ください。
          </p>
          <div class="login_block">
            <div class="" v-if="$firebase.isAuthenticated">
              <PaymentForm :serviceName="serviceName" :price="price" :is_subscription="true" />
            </div>
            <div class="login_block__01" v-else-if="!$firebase.isAuthenticated">
              <div class="payment">
                <login-forms />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="login_container" v-else>
      <div class="renew2_wrapper renew2_flex">
        <div class="login_contents">
          <div class="renew2_flex lead">
            <h2>ヤギプライム <span><a href="/mypage/yagiprime" target="_blank" class="notelink-icon">？</a></span></h2>
          </div>
          <p class="thanks-txt">ヤギプライム会員に<br>ご登録ありがとうございます！</p>
          <p class="note-txt">ヤギプライムへのお支払いが完了しました。早速、ヤギプライムの機能を使ってみましょう！</p>
          <div class="prime-btnblock">
            <a href="/yagiprime/info" class="prime-btn">続けて希望条件を設定する</a>
          </div>
          <br>
          <div class="prime-btnblock" v-if="false">
            <a href="/mypage/yagiprime" class="prime-btn">ヤギプライムを使う</a>
            <p class="note-txt">※ マイページに遷移いたします。</p>
          </div>
        </div>
      </div>
    </div>
  </main>

</template>
<style lang="css" src="@/assets/css/renew_reset.css"></style>
<style lang="css" src="@/assets/css/renew2_style.css"></style>
<!-- <style lang="css" src="@/assets/css/renew2_login.css"></style> -->

<style lang="scss" scoped>
#renew2_login .notelink-icon {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #404040;
  color: #fff;
  text-align: center;
  line-height: 20px;
  margin-left: 5px;
  font-size: 0.8rem;
  bottom: 2px;
}

#renew2_login .note-txt {
  font-size: 0.8rem;
  margin: 10px 0 30px;
}

#renew2_login .payment-h3 {
  font-size: 1rem;
  margin-bottom: 20px;
}

#renew2_login .merit .payment-h3 {
  color: #E95B10;
}

#renew2_login .attention {
  color: #E3165C;
}

#renew2_login .payment-selectbox {
  margin-bottom: 20px;
}

#renew2_login .payment-selectbox .el-collapse-item__header {
  padding-left: 0;
}

#renew2_login .payment-btn {
  text-align: right;
}

#renew2_login .merit {
  position: relative;
  text-align: left;
}

#renew2_login .merit::after {
  position: absolute;
  content: "おすすめ！";
  --f: .5em;
  /* control the folded part*/
  --r: .8em;
  /* control the ribbon shape */

  position: absolute;
  top: -40px;
  right: -37px;
  padding-inline: .25em;
  line-height: 1.8;
  color: #fff;
  font-weight: bold;
  background: #FA6900;
  border-bottom: var(--f) solid #0005;
  border-left: var(--r) solid #0000;
  clip-path:
    polygon(0 0, 100% 0, 100% calc(100% - var(--f)), calc(100% - var(--f)) 100%,
      calc(100% - var(--f)) calc(100% - var(--f)), 0 calc(100% - var(--f)),
      var(--r) calc(50% - var(--f)/2));
}

#renew2_login .merit-list {
  list-style: auto;
  margin-left: 20px;
}

#renew2_login .merit-item .strong {
  font-weight: bold;
}
</style>
<style lang="scss" scoped>
#renew2_login .thanks-txt {
  font-weight: bold;
  font-size: 1.2rem;
}

#renew2_login .prime-btnblock {
  text-align: center;
}

#renew2_login .prime-btn {
  display: block;
  color: #fff;
  font-size: 1rem;
  font-weight: bold;
  background: #004d40;
  width: 250px;
  margin: 0 auto;
  border-radius: 50px;
  padding: 10px 0;
  transition-duration: .4s;
}

#renew2_login .notelink-icon:hover {
  text-decoration: none;
}

#renew2_login .prime-btn:hover {
  transform: scale(1.1);
}

#renew2_login .login_container .login_block__01 {
  background: #fff;
  width: 100%;
  padding: 3px;
  border-radius: 10px;
  margin-right: 10px;
}
</style>
<style lang="scss" scoped>
#renew2_login .renew2_flex .login_contents .check_icon {
  position: relative;
  height: 16px;
  top: -5px;
}
</style>

<script>
import LoginForms from '@/components/IdPwLoginForms'
// import LoginForms from '@/components/LoginForms'
import firebase from 'firebase/app'
import { loadStripe } from '@stripe/stripe-js'
import { StripeElementCard } from '@vue-stripe/vue-stripe'
import PaymentForm from '@/components/Payment/PaymentMethodSelector.vue'

export default {
  components: {
    'login-forms': LoginForms,
    StripeElementCard,
    PaymentForm
  },
  data: function () {
    return {
      isPaymentYagiprime: true,
      isCampaign4Me: false,
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      fullscreenLoading: false,
      paymentMethod: 'card',
      paymentMethodTab: 'card',
      registerComple: false,
      isCampaign: false,
      trial_campaign_id: 0,
      stripe: null,
      elements: null,
      paymentRequest: null,
      prButton: null,
      isApplePayAvailable: false,
      expressCheckoutElement: null,
      clientSecret: null,
      serviceName: 'ヤギプライム',
      price: 550
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    updateLoadingState(isLoading) {
      this.fullscreenLoading = isLoading
    },
    tokenCreated(token, merchant_payment_id = '') {
      const app = this
      app.isPaymentYagiprime = false
      app.$eventHub.$emit('loading_on')
      this.token = ""
      if (token) {
        this.token = token.id
      }
      if (merchant_payment_id) {
        this.paymentMethodTab = 'paypay'
      }
      const formData = new FormData()
      formData.append('stripe_token', this.token)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('subscription_type', 1)
      if (app.isCampaign) {
        formData.append('trial_campaign_id', app.trial_campaign_id)
      }

      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      formData.append('payment_method', this.paymentMethodTab)
      app.fullscreenLoading = true
      this.$axios
        .post(this.$varuna.endPoints.subscription, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.status)

          if (response.status == 201) {
            const subformData = new FormData()


            var route_id = app.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
            if (route_id) {
              subformData.append('route', route_id)
            } else {
              subformData.append('route', '')
            }
            subformData.append('uuid', app.$firebase.user.uid)
            app.$axios
              .post(app.$varuna.endPoints.setYagiprimeEntrySource, subformData, { timeout: 60000 })

            app.$message({
              message: '購入完了しました',
              type: 'success'
            })
            app.registerComple = true
          }
        })
        .catch(function (error) {
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
          app.$eventHub.$emit('payment_yagiprime_result', 'error')
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    yagiprimePaypay: function (param) {
      const app = this
      app.fullscreenLoading = true

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('subscription_type', 1)

      var route_id = app.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
      if (route_id) {
        formData.append('route', route_id)
      } else {
        formData.append('route', '')
      }
      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      formData.append('redirect_url', window.location.href)
      this.$axios
        .post(this.$varuna.endPoints.paypaySubscriptions, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.authorization_url);
          location.href = response.data.authorization_url
        })
        .catch(function (error) {
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
          app.$eventHub.$emit('payment_yagiprime_result', 'error')
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    paymentResult: function (param) {
      this.fullscreenLoading = false
      if (param == 'success') {
        this.currentCardId = 'complete'
        this.goCurrentCard()
        this.scrollToCurrentStep()
      }
    },
    loadingOn: function () {
      this.fullscreenLoading = true
    },
    loadingOff: function () {
      this.fullscreenLoading = false
    },
    paymentYagiprime: function () {
      console.error(this.paymentMethod)
      const app = this
      if (app.isPaymentYagiprime && this.paymentMethod == 'card') {
        this.$refs.stripeCardElememt.submit()
      }
    },
    authStateChanged: async function () {
      const app = this
      app.fullscreenLoading = true
      this.$axios
        .get(this.$varuna.endPoints.isSubscribed + this.$firebase.user.uid + '/', null, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.is_subscribed)
          if (response.data.is_subscribed) {
            // app.$router.push('/mypage/yagiprime')
            // location.href = '/mypage/yagiprime'
            app.registerComple = true
          }

        })
        .catch(function (error) {

        }).finally(function () {
          app.fullscreenLoading = false
        })

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      this.$axios
        .post(this.$varuna.endPoints.canUseTrialCampaign, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.can_use_trial_campaign)
          if (response.data.can_use_trial_campaign) {
            app.isCampaign4Me = true
          } else {
            app.isCampaign4Me = false
            app.isCampaign = false
            app.trial_campaign_id = null
          }

        })
        .catch(function (error) {

        }).finally(function () {
          app.fullscreenLoading = false
        })
      // const urlParams = new URLSearchParams(window.location.search);
      // var from_page = urlParams.get("frompage");
      // if (from_page) {
      //   this.$router.push('/format/' + from_page + '/edit/output')
      // } else {
      //   this.$router.push('/mypage')
      // }
      // console.log('new login created')
    },
    async onPaymentMethodReceived(ev) {
      try {
        // サーバーにPaymentIntentを作成するリクエストを送信
        const { data } = await this.$axios.post('/create-payment-intent', {
          payment_method: ev.paymentMethod.id,
          amount: 550, // 金額（最小単位）
          currency: 'jpy',
          uuid: this.$firebase.user.uid
          // その他必要なデータ
        });

        const clientSecret = data.client_secret

        // 支払いを確認
        const confirmResult = await this.stripe.confirmCardPayment(clientSecret, {
          payment_method: ev.paymentMethod.id
        }, { handleActions: false })

        if (confirmResult.error) {
          // エラーが発生した場合
          ev.complete('fail');
          console.error(confirmResult.error.message)
          this.$message({
            message: '支払いに失敗しました。',
            type: 'error'
          });
        } else {
          // 支払い成功
          ev.complete('success')
          this.registerComple = true
          this.$message({
            message: '支払いが完了しました。',
            type: 'success'
          })
        }
      } catch (error) {
        ev.complete('fail')
        console.error('支払いエラー:', error)
        this.$message({
          message: '支払いに失敗しました。',
          type: 'error'
        })
      }
    },
    async applePayComplete() {
      this.fullscreenLoading = true
      console.log('Apple Pay 完了処理を開始しました。')

      // パラムを確認して、Apple Pay の支払いを確認
      const urlParams = new URLSearchParams(window.location.search)
      const paymentIntent = urlParams.get('payment_intent')
      const paymentIntentClientSecret = urlParams.get('payment_intent_client_secret')
      const redirectStatus = urlParams.get('redirect_status')
      console.log('URL パラメータを取得しました。paymentIntent:', paymentIntent, 'redirectStatus:', redirectStatus, 'paymentIntentClientSecret:', paymentIntentClientSecret)

      if (paymentIntent && redirectStatus === 'succeeded') {
        console.log('支払いが成功したと報告されています。Stripe をロードします。')
        const stripe = await loadStripe(this.publishableKey)

        // PaymentIntent のステータスを確認
        console.log('5秒待機します。')
        await new Promise(resolve => setTimeout(resolve, 1000))

        console.log('PaymentIntent のステータスを取得します。')
        const { paymentIntent: { status } } = await stripe.retrievePaymentIntent(paymentIntentClientSecret)
        console.log('PaymentIntent のステータス:', status)

        if (status === 'succeeded') {
          console.log('支払いが成功しました。')
          this.registerComple = true
          this.$message({
            message: '支払いが完了しました。',
            type: 'success'
          })
        } else {
          console.log('支払いが失敗しました。')
          this.$message({
            message: '支払いに失敗しました。',
            type: 'error'
          })
        }

        if (error) {
          console.error('支払いエラー:', error)
          this.$message({
            message: '支払いに失敗しました。',
            type: 'error'
          })
        } else {
          console.log('支払いが成功しました。')
          this.registerComple = true
          this.$message({
            message: '支払いが完了しました。',
            type: 'success'
          })
        }
      } else {
        console.log('支払いが成功しませんでした。fullscreenLoading を false に設定します。')
        this.fullscreenLoading = false
      }
    }

  },
  async mounted() {
    this.applePayComplete()
  },
  created: function () {
    console.log('created')
    const app = this

    this.$axios
      .get(this.$varuna.endPoints.getTrialCampaign, null, { timeout: 60000 })
      .then(function (response) {
        console.error(app.isCampaign)
        console.error(response.data[0])
        const today = new Date(); // 本日の日付
        const startDate = new Date(response.data[0].trial_campaign_start_date)
        const endDate = new Date(response.data[0].trial_campaign_end_date)

        // キャンペーンが有効かつ、本日がキャンペーン期間内かを確認
        if (response.data[0].trial_campaign_is_active && today >= startDate && today <= endDate) {
          app.isCampaign = true
          app.trial_campaign_id = response.data[0].trial_campaign_id
        }
        console.error(app.isCampaign)
      })
      .catch(function (error) {
      }).finally(function () {
        app.fullscreenLoading = false
      })
  },
  beforeMount: function () {
    this.$eventHub.$on('payment_yagiprime_result', this.paymentResult)
    this.$eventHub.$on('loading_on', this.loadingOn)
    this.$eventHub.$on('loading_off', this.loadingOff)
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('payment_yagiprime_result', this.paymentResult)
    this.$eventHub.$off('loading_on', this.loadingOn)
    this.$eventHub.$off('loading_off', this.loadingOff)
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
  }
}
</script>
